import React, { useEffect } from 'react';
import Footer from "../../../components/Footer/Footer";
import { useNavigate } from "react-router-dom";
import { useScrollHeader } from '../../../hooks';
import NewsSidebar from "../../../components/NewsSidebar/NewsSidebar";
import './academic.less';

export default function Academic({ setHeaderDark }) {
  useScrollHeader(setHeaderDark, 50); // 50px 触发
  const navigate = useNavigate();

  const newsData = [
    {
      title: '温州医科大学附属眼视光医院＆集视医疗战略合作签约',
      date: '2024-10-31',
      desc: '2024年10月，集视医疗与温州医科大学附属眼视光医院达成了一项具有里程碑意义的战略合作协议。根据协议，集视医疗的视功能训练产品将正式入驻温州医科大学附属眼视光医院的视功能训练室…',
      img: '/images/news/news1.png',
      route: '/newsInfo/contract'
    },
    // {
    //   title: '集视医疗弱视方案临床试验初步访视结果出炉，001号患者4周基本治愈！',
    //   date: '2024-10-11',
    //   desc: '苏州集视医疗科技有限公司（以下简称“集视医疗”）于国内由复旦大学附属眼耳鼻喉科医院牵头，联合多中心开展的全球首个“基于AR技术的全年龄段弱视治疗方案的有效性和安全性”的前瞻性…',
    //   img: '/images/news/news2.png',
    //   route: '/newsInfo/amblyopiaClinical'
    // },
    {
      title: '集视医疗完成Pre-A轮融资',
      date: '2024-08',
      desc: '据悉，集视医疗已于近期完成由复健资本独家投资的Pre-A轮融资。随着本轮资金的成功注入，集视医疗将大幅提升产能，不断巩固和拓展其全年龄段弱视治疗方案，扎实推进已获批产品的商业化进程…',
      img: '/images/news/news4.png',
      route: '/newsInfo/pre'
    },
    {
      title: '卓悦榜丨集视医疗荣膺“年度智慧医疗最佳企业”奖项',
      date: '2024-04-26',
      desc: '2024年4月26日，浩悦资本正式发布了“2024第八届医疗健康投资卓悦榜”，集视医疗荣膺“年度智慧医疗最佳企业”奖项。',
      img: '/images/news/bestEnterprise3.png',
      route: '/newsInfo/bestEnterprise'
    },
  ]

  useEffect(() => {
    window.scrollTo(0, 0); // 进入页面时滚动到顶部
  }, []);

  return <div className="PreA">
    <div className="nav">
      <div className="AcademicMargin flex_row flex_jc-sb flex_ai-c gap_10" style={{ height: '100%' }}>
        <div className='nav_title c_ff'>公司动态 / 最新资讯 / 集视医疗亮相中华医学会第二十八次眼科学术大会</div>
        <div
          className='fz_20 fw_500 lh_24 c_ff cur_p flex_row flex_ai-c'
          onClick={(() => navigate('/companyNews', { replace: true }))}
        >
          <img
            className='nav_arrow'
            src='/images/news/left.png'
            alt=''
          />
          <div className='nav_back'>返回页面</div>
        </div>
      </div>
    </div>
    <div className="AcademicBlock">
      <div className='PreA_left'>
        <div className='PreA_marginMobile flex_col flex_jc-sb'>
          <div>
            <div className="article_title">
              <div className='article_titleTop c_85899E'>
                公司动态 / 公司资讯
                <span className='ml_54'>2024.09.08</span>
              </div>
              <div className="article_titleBottom">集视医疗亮相中华医学会第二十八次眼科学术大会</div>
            </div>
            <div className="article_content">
              <div className="article_content-text">
                2024年9月4-8日，中华医学会第二十八次眼科学术大会在武汉国际博览中心隆重举行，作为年度眼科行业最盛大的学术会议，全球逾万名专家、学者相聚于此，交流分享眼科和视觉科学方面最新研究成果。
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/academic3.png'
                  alt=''
                />
              </div>
              <div className="article_content-text">
                {/* 集视医疗十年磨一剑，多款眼科创新型产品：埃尔塔™全年龄弱视治疗仪、爱格视™多功能3D近视训练仪、眼派™可视温润舒眼仪首次亮相眼科年会。展示了全新的弱视治疗、近视防控和干眼护理的解决方案，为眼科诊疗范式革新注入一股强劲的“中国力量”！ */}
                集视医疗十年磨一剑，多款眼科创新型产品：埃尔塔™视觉功能训练治疗软件、爱格视™多功能3D近视训练仪、眼派™可视温润舒眼仪首次亮相眼科年会。展示了全新的弱视治疗、近视防控和干眼护理的解决方案，为眼科诊疗范式革新注入一股强劲的“中国力量”！
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/academic2.png'
                  alt=''
                />
              </div>
              <div className="article_content-text">
                会议期间，集视医疗展示的产品吸引了众多专家学者和商业投资领域的访客前来交流，就临床治疗方案的革新和产品设计理念进行了深入的研讨，收获了各领域大咖的一致肯定。
                <br />
                <br />
                2024CCOS是集视医疗首次参与眼科临床的学术交流，集视医疗将以2024全国眼科年会为起点，进一步加强与医生、学者的沟通和交流，旨在以开放合作的心态为行业赋能，共同推进我国眼科行业的健康发展。
              </div>
            </div>
          </div>
          <div className='article_content'>
            <div className='article_content-iconBlock'>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Share_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Collection_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/link_icon.png'
                  alt=''
                />
              </div>
            </div>
            <div className='article_content-btnBlock'>
              {/* Pc端 */}
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                // onClick={(() => navigate('/newsInfo/amblyopiaClinical'))}
                onClick={(() => navigate('/newsInfo/contract'))}
              >
                <img
                  className='nav_arrow mr_10'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                阅读上一篇资讯
              </div>
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/pre'))}
              >
                阅读下一篇资讯
                <img
                  className='nav_arrow ml_10'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
              {/* 移动端 */}
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                // onClick={(() => navigate('/newsInfo/amblyopiaClinical'))}
                onClick={(() => navigate('/newsInfo/contract'))}
              >
                <img
                  className='nav_arrow mr_6'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                上一篇
              </div>
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/pre'))}
              >
                下一篇
                <img
                  className='nav_arrow ml_6'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <NewsSidebar newsData={newsData} />
    </div>
    <Footer />
  </div>
}
